
import React from 'react';
// IMG
import logo from '../../../Images/logo.png'

// UI
import { ImgUI } from '../../UI/ImgUI/ImgUI'

export const ContainerImgForgotPass = () => {
  return (
    <div className="img">
        <ImgUI  style='imgLogo' routeImg={logo}/>
     </div>
  )
}
